import {type PayloadAction, createSlice} from '@reduxjs/toolkit';

import type {AppState} from 'src/store/typedef';

export type InitialState = {
    selectedColumns: string[],
};

const initialState: InitialState = {
    selectedColumns: [],
};

export const userSearchResultColumns = createSlice({
    name: 'userSearchResultColumns',
    initialState,
    reducers: {
        updateSelectedUserSearchColumns: (state, action: PayloadAction<string[]>) => {
            state.selectedColumns = action.payload;
        },
        clearSelectedColumns: state => {
            state.selectedColumns = [];
        },
    },
});

export const {
    updateSelectedUserSearchColumns,
} = userSearchResultColumns.actions;

export const selectSelectedColumns = (state: AppState) => state.userSearchResult.columns.selectedColumns;
